import React, { Component } from "react";
import {
  Button,
  FormFeedback,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import Joi from "joi-browser";
import httpClient from "../http-client/client";

const COUNTDOWN  = 60;

class VerificationModal extends Component {
  state = {
    verificationCode: "",
    errors: {},
    countdown: COUNTDOWN,
    enable: true
  };

  schema = Joi.object().keys({
    verificationCode: Joi.string()
      .required()
      .error(errors => {
        return {
          message: " کوڈ درج کریں"
        };
      })
  });

  componentDidMount() {
    this.startCountDown();
  }

  componentWillUnmount() {
    this.stop();
  }

  startCountDown = () => {
    // update every second
    this.interval = setInterval(() => {
      let countdown = this.state.countdown;

      if (countdown === 0) {
        // enable resend button
        this.setState({ enable: false });
      } else {
        // decrement countdonw by 1;

        countdown !== 0 &&
          this.setState(prevState => ({ countdown: prevState.countdown - 1 }));
      }
    }, 1000);
  };

  stop = () => {
    clearInterval(this.interval);
  };
  //change handler
  handleChange = event => {
    let value = event.target.value;

    this.setState({ [event.target.name]: value });
  };

  validation() {
    let { error } = Joi.validate(
      { verificationCode: this.state.verificationCode },
      this.schema,
      {
        abortEarly: false
      }
    );

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }


  resendVerficationCode = async () => {

    try {
      let {mobileNumber,mobileOperatorId} = this.props;
      let payload = {mobileNumber,mobileOperatorId}
      let  {status} = await httpClient.post("/user/resend_verification_code",payload);

      if(status === 200){
        this.setState({ enable: true, countdown: COUNTDOWN });
      }
    } catch (error) {
      
    }
    

  };

  // Submit handler
  handleSubmit = async event => {
    event.preventDefault();

    // validation
    let errors = this.validation();
    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    this.props.handleVerfication(this.state.verificationCode);
  };

  render() {
    let { verificationCode, errors } = this.state;
    let { mobileNumber } = this.props;


    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.closeModal}
          className="text-right"
        >
          <ModalHeader toggle={this.closeModal}>
            موبائل نمبر کی تصدیق کریں
          </ModalHeader>
          <ModalBody>
            <p>آپ کا تصدیقی کوڈ مندرجہ ذیل نمبر پہ بھیج دیا گیا ہے</p>
            <Input
              value={mobileNumber}
              name="mobileNumber"
              placeholder="موبائل نمبر"
              disabled
              className="mb-3"
              // invalid={Boolean(errors["mobileNumber"])}
              // onChange={this.handleChange}
            />

            <Input
              value={verificationCode}
              name="verificationCode"
              placeholder="تصدیقی کوڈ"
              invalid={Boolean(errors["verificationCode"])}
              onChange={this.handleChange}
            />
            {errors["verificationCode"] && (
              <FormFeedback>{errors["verificationCode"]}</FormFeedback>
            )}
            <div className="text-danger">{this.props.verificatonMessage}</div>
            <div className="mt-2">
              {" "}
              <Button
                className="mr-2"
                color="info"
                onClick={this.resendVerficationCode}
                disabled={this.state.enable}
              >
                کوڈ دوبارہ بھیجیں
              </Button>
              تصدیق کوڈ کو {this.state.countdown} سیکنڈ میں بھیجیں۔
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={this.handleSubmit}>
              تصدیق کریں
            </Button>
            <Button color="danger" onClick={this.props.closeModal}>
              منسوخ کریں
            </Button>
          </ModalFooter>
        </Modal>

        {/* End verification Modals */}
      </div>
    );
  }
}

export default VerificationModal;
